<template>
  <!-- 试卷统计 -->
  <div id="examTotal">
    <div class="select-job">
      <li class="job-title">{{$t('translateText.kstj.xzsj')}}:</li>
      <li>
        <a-select
          v-model="defaultExamina"
          style="width: 200px"
          @change="examinaChange"
          :dropdownStyle="{zIndex:1000}"
        >
          <a-select-option v-for="(item, i) in homeworks" :key="i">
            {{ item.examination.strExaminationName }}
          </a-select-option>
        </a-select>
      </li>
      <li class="job-title">{{$t('translateText.kstj.xzbj')}}:</li>
      <li>
        <a-select
          v-model="defaultClass"
          style="width: 200px"
          @change="classChange"
        >
          <a-select-option v-for="(item, i) in userClass" :key="i">
            {{ item.strClassName }}
          </a-select-option>
        </a-select>
      </li>
    </div>
    <div class="exam-area">
      <div class="exam-arealist">
        <div class="select-trend" v-show="this.objlenth.length!=0">
        <li>
          <div class="Echarts" >
            <div id="main" style="width: 500px; height: 350px"></div>
          </div>
        </li>
        <li>
          <span>{{$t('translateText.kstj.pjf')}}:{{ average }} </span>
          <span>{{$t('translateText.kstj.zgf')}}:{{ topGrade }} </span>
          <span>{{$t('translateText.kstj.zdf')}}:{{ minGrade }} </span>
        </li>
        </div>
        <div class="zwshuju" v-show="this.objlenth.length==0">
            <div class="trend-title">{{$t('translateText.kstj.zst')}}</div>
                <a-empty :description="$t('translateText.kstj.zwsj')"/>
            </div>
        </div>
      <div class="select-detail">
        <div class="detail-tools">
          <li class="tools-title">{{$t('translateText.kstj.ksmx')}}</li>
          <li>
            <one-button :color="true" @click="download1">{{$t('translateText.kstj.dccj')}}</one-button>
            <!-- <download-excel
              class="export-excel-wrapper"
              :data="data"
              :fields="json_fields"
              name="考试成绩明细.xls"
            >
              <one-button :color="true">导出成绩</one-button>
            </download-excel> -->
          </li>
        </div>
        <err-table
          :Show="false"
          :columns="columns"
          :data2="tableData"
          :height="{ y: 250 }"
        ></err-table>
      </div>
    </div>
  </div>
</template>

<script>
import errTable from "@/components/Table/Table";
import {
  getExaminationReleaseByCourse,
  getClassListByRelease,
  getScoreListByRelease,
} from "@/utils/api";
import json2csv from "json2csv";
import CsvExportor from "csv-exportor";
// import echarts from "echarts/lib/echarts";
export default {
  name: "Echarts",
  data() {
    return {
      objlenth:[],
      myChart: null, //饼状图
      homeworks: [], //试卷列表
      userClass: [], //用户班级
      selectExamReleaseId: 0, //选中的试卷
      defaultExamina: "", //默认选择的试卷
      defaultClass: "", //默认选择的班级
      selectClassId: 0, //选择的班级id
      average: 0, //平均分
      topGrade: 0, //最高
      minGrade: 0, //最低分
      //饼状图option

      tableData:[],
      fields: ["key", "info", "type", "detail", "startTime"],
      json_fields: {
        学员: "key",
        班级: "info",
        姓名: "type",
        成绩: "detail",
        排名: "startTime",
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 ",
          },
        ],
      ],
    };
  },
  methods: {
    //获取所有已发布的试卷
    getpublishedwork() {
      let courseid = localStorage.getItem("courseId");
      getExaminationReleaseByCourse({
        iCourseId: courseid,
        iExaminationType: 0,
        strExaminationName: "",
      }).then((response) => {
        this.homeworks = response.data.objData;
        if (this.homeworks.length > 0) {
          this.selectExamReleaseId = this.homeworks[0].iExamReleaseId;
          this.defaultExamina =
            this.homeworks[0].examination.strExaminationName;
          this.getClassListByRelease();
        }
      });
    },
    //根据试卷发布查询发布了几个班级
    getClassListByRelease() {
      getClassListByRelease({
        iExamReleaseId: this.selectExamReleaseId,
      }).then((response) => {
        this.userClass = response.data.objData;
        if (this.userClass.length > 0) {
          this.selectClassId = this.userClass[0].iClassId;
          this.defaultClass = this.userClass[0].strClassName;
          this.getScoreListByRelease();
        }else{
          this.defaultClass =[]
          this.getScoreListByRelease();
        }
    
      });
    },
    //根据试卷/作业id查询每个同学分数情况
    getScoreListByRelease() {
      getScoreListByRelease({
        iExamReleaseId: this.selectExamReleaseId,
        iClassId: this.selectClassId,
        iExaminationState: 5,
      }).then((response) => {
       
        let grade = [
          { value: 0, name: this.$t('translateText.kstj.6')},
          { value: 0, name: this.$t('translateText.kstj.67')},
          { value: 0, name: this.$t('translateText.kstj.78')},
          { value: 0, name: this.$t('translateText.kstj.89')},
          { value: 0, name: this.$t('translateText.kstj.91')},
        ];
        let allGrades = [];
        this.tableData = [];
        this.objlenth=response.data.objData
        if(response.data.objData.length!=0){

        for (let i = 0; i < response.data.objData.length; i++) {
          let examination = response.data.objData[i];
          let iScore = examination.iScore;
          //表格数据
          let tableRow = {
            key: examination.user.strUserName,
            info: examination.user.userClass.strClassName,
            type: examination.user.strRealName,
            detail: iScore,
            startTime: i + 1,
          }
          ;
          this.tableData.push(tableRow);
          allGrades.push(iScore);
          if (iScore < 60) {
            grade[0].value++;
          }
          if (60 <= iScore && iScore < 70) {
            grade[1].value++;
          }
          if (70 <= iScore && iScore < 80) {
            grade[2].value++;
          }
          if (80 <= iScore && iScore < 90) {
            grade[3].value++;
          }
          if (90 <= iScore && iScore <= 100) {
            grade[4].value++;
          }
        }
        this.average = Math.round(
          allGrades.reduce((a, b) => a + b) / allGrades.length
        );
        this.topGrade = Math.max(...allGrades);
        this.minGrade = Math.min(...allGrades);
        let option = this.option;
        option.series[0].data = grade;
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption(option);

        }
       
          
      });
    },
    //试卷下拉列表发生改变
    examinaChange(v) {
      this.selectExamReleaseId = this.homeworks[v].iExamReleaseId;
      this.getClassListByRelease();
    },
    //班级下拉列表发生改变
    classChange(v) {
      this.selectClassId = this.userClass[v].iClassId;
      this.getScoreListByRelease();
    },
    download1() {
      let tableData = this.tableData;
      let header = [this.$t('translateText.kstj.xh'), this.$t('translateText.kstj.bj'), this.$t('translateText.kstj.xm'), this.$t('translateText.kstj.cj'), this.$t('translateText.kstj.pm')];
      CsvExportor.downloadCsv(tableData, { header },  `${this.$t('translateText.kstj.excel')}.csv`);
    },
    download() {
      try {
        const result = json2csv.parse(this.data, {
          fields: this.fields,
          excelStrings: true,
        });
        if (this.MyBrowserIsIE()) {
          // IE10以及Edge浏览器
          var BOM = "\uFEFF";
          // 文件转Blob格式
          var csvData = new Blob([BOM + result], { type: "text/csv" });
          navigator.msSaveBlob(csvData, `a.csv`);
        } else {
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
          // 非ie 浏览器
          this.createDownLoadClick(csvContent, `a.csv`);
        }
      } catch (err) {
        alert(err);
      }
    },
    //创建a标签下载
    createDownLoadClick(content, fileName) {
      const link = document.createElement("a");
      link.href = encodeURI(content);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 判断是否IE浏览器
    MyBrowserIsIE() {
      let isIE = false;
      if (
        navigator.userAgent.indexOf("compatible") > -1 &&
        navigator.userAgent.indexOf("MSIE") > -1
      ) {
        // ie浏览器
        isIE = true;
      }
      if (navigator.userAgent.indexOf("Trident") > -1) {
        // edge 浏览器
        isIE = true;
      }
      return isIE;
    },
    myEcharts() {
      this.myChart = this.$echarts.init(document.getElementById("main"));
      let option = this.option;
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
  components: {
    errTable,
 

  },
  mounted() {
    this.getpublishedwork();
    this.myEcharts();
  },
  computed:{
    columns() {
     return [
        {
            title: this.$t('translateText.kstj.xh'),
            dataIndex: "key",
            align: "center",
        },
        {
            title: this.$t('translateText.kstj.bj'),
            dataIndex: "info",
            ellipsis: true,
        },
        {
            title: this.$t('translateText.kstj.xm'),
            dataIndex: "type",
            ellipsis: true,
        },
        {
            title: this.$t('translateText.kstj.cj'),
            dataIndex: "detail",
            ellipsis: true,
        },
        {
            title: this.$t('translateText.kstj.pm'),
            dataIndex: "startTime",
            ellipsis: true,
            align: "center",

        },
      ];
    },
    option(){
      return  {
            title: {
                text: this.$t('translateText.kstj.zst'),
                left: "center",
            },
            tooltip: {
                trigger: "item",
            },
            legend: {
                orient: "vertical",
                left: "left",
            },
            series: [
            {
                name: this.$t('translateText.kstj.rs'),
                type: "pie",
                radius: "50%",
                data: [],
                emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                },
                },
            },
            ],
        }
    },
  }
};
</script>


<style lang="less" scoped>
#examTotal {
  height: 100%;
  width: 100%;
  padding: 0 3% 0 2%;
  overflow: hidden;
  .select-job {
    margin: 2% 0 1% 0;
    height: 16%;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #eaf7f7;
    .job-title {
      margin: 0 2%;
      font-size: 15px;
      font-weight: 550;
      color: #505050;
    }
  }
  /deep/.ant-select-dropdown{
    z-index: 1000 !important;
  }
  .exam-area {
    display: flex;
    width: 100%;
    height: 75%;
    // background-color: #ff6700;
    .select-trend {
      margin-left: 10%;
      // display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // justify-content: center;
      width: 50%;
      height: 100%;
      // background-color: #333;
      .trend-title {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333e5f;
      }
    }
    .select-detail {
      width: 50%;
      height: 100%;
      // background-color: #333;
      // background-color: #555;
      .detail-tools {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 18%;
        .tools-title {
          color: #333e5f;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .zwshuju{
       flex: 1;
       width :100%;
       height:80%;
      //  border: 1px solid #000;
       margin-right: 50%;
        // margin-top: 20%;
       .trend-title{
         margin-top: 5px;
         margin-bottom: 14%;
         font-size: 18px;
         font-weight: 600;

       }
    }
    
  }
}
.exam-arealist{
  width: 50%;
}
</style>